module.exports = __webpack_public_path__ + "img/Client.f19aa45b.png";